import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import {
    Box,
    Button,
    Dialog,
    Flex,
    Heading,
    IconButton,
    Text,
    Textarea,
    VStack
} from '@chakra-ui/react';
import { FiX } from 'react-icons/fi';

const SendToBlacklistModal = ({ agent, sourceTable, onClose, onConfirm }) => {
    const [reason, setReason] = useState('');
    const [loading, setLoading] = useState(false);

    const handleConfirm = async () => {
        setLoading(true);
        try {
            await onConfirm(agent.id, sourceTable, reason);
            onClose();
        } catch (error) {
            console.error('Error sending to blacklist:', error);
            alert('Failed to move agent to blacklist: ' + (error.response?.data?.error || error.message));
        } finally {
            setLoading(false);
        }
    };

    return createPortal(
        <Dialog.Root open={true} onOpenChange={(e) => !e.open && onClose()}>
            <Dialog.Backdrop bg="blackAlpha.600" backdropFilter="blur(4px)" zIndex={9999} />
            <Dialog.Positioner zIndex={10000}>
                <Dialog.Content maxW="md" borderRadius="xl" boxShadow="2xl" bg="white" p={6}>
                    <Flex justify="space-between" align="center" mb={4}>
                        <Heading size="md" color="red.600" fontWeight="bold">
                            🚫 Send to Blacklist
                        </Heading>
                        <IconButton
                            size="sm"
                            variant="ghost"
                            onClick={onClose}
                            aria-label="Close"
                        >
                            <FiX />
                        </IconButton>
                    </Flex>

                    <VStack align="stretch" spacing={4}>
                        <Box bg="red.50" p={4} borderRadius="lg" border="1px solid" borderColor="red.200">
                            <Text fontWeight="bold" color="gray.800" mb={1}>
                                {agent.agent_name || 'Unknown Agent'}
                            </Text>
                            <Text fontSize="sm" color="gray.600">
                                Country: {agent.country || 'N/A'}
                            </Text>
                        </Box>

                        <Box>
                            <Text fontWeight="medium" mb={2} color="gray.700">
                                Reason for blacklisting (optional):
                            </Text>
                            <Textarea
                                value={reason}
                                onChange={(e) => setReason(e.target.value)}
                                placeholder="Enter the reason why this agent should be blacklisted..."
                                rows={4}
                                resize="vertical"
                            />
                        </Box>

                        <Text fontSize="sm" color="gray.500">
                            ⚠️ This will move the agent to the blacklist and remove it from the current list.
                        </Text>

                        <Flex gap={3} justify="flex-end" pt={2}>
                            <Button variant="outline" onClick={onClose} disabled={loading}>
                                Cancel
                            </Button>
                            <Button
                                colorPalette="red"
                                onClick={handleConfirm}
                                loading={loading}
                                loadingText="Moving..."
                            >
                                Confirm Blacklist
                            </Button>
                        </Flex>
                    </VStack>
                </Dialog.Content>
            </Dialog.Positioner>
        </Dialog.Root>,
        document.body
    );
};

export default SendToBlacklistModal;
